import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faArrowDownLeftAndArrowUpRightToCenter, faArrowUpRightAndArrowDownLeftFromCenter, faXmark, } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import styled, { css } from "styled-components";
import { NewButton } from "../../button";
import { cssBody400, cssDisplay100Bold } from "../../typography/styles";
const _ModalTitle = ({ fullSize, hideCloseButton, onClose, resizable, onFullSizeClick, title, subtitle, titleAlign, size, className, }) => {
    // console.log("🚀 ~ file: ModalTitle.tsx:29 ~ size:", size);
    const hasCloseButton = onClose && !hideCloseButton;
    const hasButtons = hasCloseButton || resizable;
    const buttonsWidth = useMemo(() => {
        if (titleAlign !== "center") {
            return "20%";
        }
        else {
            return ([resizable, hasCloseButton].reduce((acc, val) => {
                if (acc > 0) {
                    acc += 8; // gap
                }
                if (val) {
                    acc += 32;
                }
                return acc;
            }, 0) + "px");
        }
    }, [hasCloseButton, resizable, titleAlign]);
    return (_jsxs(Wrapper, { "$size": size, className: className, children: [hasButtons && titleAlign === "center" && _jsx(Buttons, { "$width": buttonsWidth }), (title || subtitle) && (_jsxs(Title, { "$textAlign": titleAlign, "$hasButtons": hasButtons, children: [title, !!subtitle && _jsx(Subtitle, { children: subtitle })] })), hasButtons && (_jsxs(Buttons, { "$width": buttonsWidth, children: [resizable && (_jsx(NewButton, { "data-testid": "resize-button", buttonType: "icon", size: "100", icon: _jsx(FontAwesomeIcon, { icon: fullSize
                                ? faArrowDownLeftAndArrowUpRightToCenter
                                : faArrowUpRightAndArrowDownLeftFromCenter }), onClick: onFullSizeClick })), onClose && !hideCloseButton && (_jsx(NewButton, { "data-testid": "close-button", buttonType: "icon", size: "100", icon: _jsx(FontAwesomeIcon, { icon: faXmark }), onClick: onClose }))] }))] }));
};
const Title = styled.h2 `
  ${cssDisplay100Bold};
  margin: 0;
  flex: 1;
  text-align: ${(p) => p.$textAlign || "left"};

  ${(p) => css `
    color: ${p.theme.systemColors.black};
  `};

  ${(p) => p.$textAlign === "center" &&
    p.$hasButtons &&
    css `
      padding-left: ${p.theme.spacing.sp16};
      padding-right: ${p.theme.spacing.sp16};
    `}
`;
const Subtitle = styled.div `
  ${cssBody400};
  ${(p) => css `
    color: ${p.theme.systemColors.grey600};
    padding-top: ${p.theme.spacing.sp4};
  `};
`;
const Wrapper = styled.div `
  display: flex;
`;
const Buttons = styled.div `
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: ${(p) => p.$width};
`;
export const ModalTitle = Object.assign(_ModalTitle, {
    Wrapper,
    Title,
});
